export default "__VITE_ASSET__DnsMV046__"